import { DataBean } from "../DataBean";

export class QualityInspectionChangePartsItems extends DataBean {

  public async getQualityInspectionChangePartsItemsCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityInspectionChangePartsItemsCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityInspectionChangePartsItemsRender(page: number, rows: number, properties: any, fromDate: any, uptoDate: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityInspectionChangePartsItemsRender_Number_Number_java.util.Map_java.util.Date_java.util.Date",
      [page, rows, properties, fromDate, uptoDate]
    );
  }

  public async deleteQualityInspectionChangePartsItems(idqualityinspectionchangepartsitems: number): Promise<any> {
    return this.getCustomService("ProcessContractERP", "boolean_deleteQualityInspectionChangePartsItems_Number", [idqualityinspectionchangepartsitems]);
  }

  public async importChangePartItems(IDEmployee: number, data: string, idQualityInspectionChangeParts: number, year: number): Promise<any> {
    return this.getCustomService("ProcessContractERP", "java.util.List_importChangePartItems_Number_String_Number_Number", [IDEmployee, data, idQualityInspectionChangeParts, year]);
  }

  public async updateQualityInspectionChangePartsItems(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityInspectionChangePartsItems_updateQualityInspectionChangePartsItems_com.orange.finance.processcontract.bean.QualityInspectionChangePartsItems",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityInspectionChangePartsItems",
        },
      ]
    );
  }
}
